module.exports = __webpack_public_path__ + "static/media/yahoo-finance.d2adb997.png";